import { useState, useEffect } from 'react';
import Api from '../api/global.service';

/**
 * Fetches parcelas_all (vw_parcelas_croq_all) for a ciclo once, so several dashboards can share it.
 * Pass id_ciclo <= 0 to skip the request.
 * withPoly also returns the polygon GeoJSON (poligono_json), its centroid (centroide_pol_lat/lng)
 * and the map/KML fields (vw_parcelas_croq_all_with_poly).
 */
const useParcelasAll = (id_ciclo, { withPoly = false } = {}) => {
  const [parcelas, setParcelas] = useState([]);
  const [blocking, setBlocking] = useState(true);

  useEffect(() => {
    if (!(id_ciclo > 0)) return;
    // Ignore responses from a previous ciclo that arrive after the ciclo changed
    let active = true;
    setBlocking(true);

    Api.search('parcelas_all', {
      withPoly,
      sort: [{ column: 'cuenta', sort: 'asc' }],
      filter: [{ column: 'id_ciclo', operator: '=', value: id_ciclo }],
    })
      .then(response => {
        if (!active) return;
        setParcelas(response.data);
        setBlocking(false);
      })
      .catch(e => {
        if (!active) return;
        // eslint-disable-next-line no-console
        console.log('error: ', e);
        setBlocking(false);
      });

    return () => {
      active = false;
    };
  }, [id_ciclo, withPoly]);

  return { parcelas, blocking };
};

export default useParcelasAll;
